import type { AccessRuleInput } from '../data/repository';
import type { AccessRule } from './types';
import { minutesToTime, timeToMinutes } from './weekdays';

/** Editable row of the door × weekday matrix (one rule per group × door, as in the schema). */
export interface MatrixRow {
  door_id: string;
  weekdays: number;
  all_day: boolean;
  start: string; // HH:MM
  end: string; // HH:MM
}

export function rulesToMatrix(doorIds: string[], rules: AccessRule[]): MatrixRow[] {
  return doorIds.map((door_id) => {
    const r = rules.find((x) => x.door_id === door_id);
    return r
      ? { door_id, weekdays: r.weekdays, all_day: r.all_day, start: minutesToTime(r.start_minute), end: minutesToTime(r.end_minute) }
      : { door_id, weekdays: 0, all_day: false, start: '18:00', end: '22:00' };
  });
}

export type MatrixResult = { ok: true; rules: AccessRuleInput[] } | { ok: false; errors: Record<string, string> };

export function matrixToRules(rows: MatrixRow[]): MatrixResult {
  const errors: Record<string, string> = {};
  const rules: AccessRuleInput[] = [];
  for (const row of rows) {
    if (row.weekdays === 0) continue;
    if (row.all_day) {
      rules.push({ door_id: row.door_id, weekdays: row.weekdays, all_day: true, start_minute: 0, end_minute: 1440 });
      continue;
    }
    const s = timeToMinutes(row.start);
    const e = timeToMinutes(row.end === '00:00' ? '24:00' : row.end);
    if (s === null || e === null) {
      errors[row.door_id] = 'Vul een geldige begin- en eindtijd in.';
      continue;
    }
    if (e <= s) {
      errors[row.door_id] = 'De eindtijd moet na de begintijd liggen. Tot middernacht? Vul 00:00 of 24:00 in.';
      continue;
    }
    rules.push({ door_id: row.door_id, weekdays: row.weekdays, all_day: false, start_minute: s, end_minute: e });
  }
  return Object.keys(errors).length ? { ok: false, errors } : { ok: true, rules };
}
